import React from 'react'
import { Input, InputCheck, SelectAnimalFetchInput, SelectInput } from 'src/components'
import { montaTypeOptions } from 'src/constants/montaType'
import { formatDateToInputValue } from 'src/utils'
import { useFormContext } from 'react-hook-form'
import { FormattedOption } from 'src/dto/animal.dto'
import { useStyles } from '../../styles'
import { PregnancyDiagnosisFormParams } from '../..'

interface ReproductionSectionProps {
  useDateInterval: boolean
  handleToggleDateInterval: () => void
}

export const ReproductionSection: React.FC<ReproductionSectionProps> = ({
  useDateInterval,
  handleToggleDateInterval
}) => {
  const style = useStyles()
  const {
    watch,
    setValue,
    clearErrors,
    setError,
    formState: { errors }
  } = useFormContext<PregnancyDiagnosisFormParams>()

  const today = new Date().toISOString().split('T')[0]

  const validateDateNotFuture = (value: string, fieldName: string, fieldLabel: string) => {
    const selectedDate = new Date(value)
    const todayDate = new Date(today)

    if (selectedDate > todayDate) {
      setError(fieldName as any, { message: `${fieldLabel} não pode ser superior à data de hoje` })
      return false
    }
    return true
  }

  return (
    <section className={`${style.section} ${style.reproductionSection}`}>
      <h2 className={style.sectionTitle}>Dados da Reprodução</h2>
      <div className={style.reproductionInfoContainer}>
        <div className={`${style.infoGrid} ${useDateInterval ? style.singleColumnGrid : ''}`}>
          <div className={style.formControl}>
            <SelectInput
              label='Tipo de reprodução'
              value={watch('tipoReproducao') || ''}
              options={montaTypeOptions}
              selectBy='id'
              showBy={['value']}
              placeholder='Selecionar tipo de reprodução'
              error={errors?.tipoReproducao?.message}
              onChange={(option: any) => {
                setValue('tipoReproducao', option?.id || '', { shouldDirty: true })
              }}
            />
          </div>

          {!useDateInterval && (
            <div className={style.formControl}>
              <Input
                type='date'
                max={today}
                label='Data'
                id='dataCobertura'
                value={formatDateToInputValue(watch('dataCobertura'))}
                error={errors?.dataCobertura?.message}
                onChange={(value: string) => {
                  if (validateDateNotFuture(value, 'dataCobertura', 'Data')) {
                    clearErrors('dataCobertura')
                  }
                  setValue('dataCobertura', value, { shouldDirty: true })
                }}
              />
            </div>
          )}
        </div>

        <div className={style.formControl}>
          <InputCheck
            id='intervalo_data_cobertura'
            type='checkbox'
            name='date_interval'
            value='intervalo'
            label='Intervalo de datas'
            checked={useDateInterval}
            onChange={handleToggleDateInterval}
          />
        </div>

        {useDateInterval && (
          <div className={style.infoGrid}>
            <div className={style.formControl}>
              <Input
                type='date'
                max={today}
                label='Data início'
                id='data_inicio'
                value={formatDateToInputValue(watch('dataInicial'))}
                error={errors?.dataInicial?.message}
                onChange={(value: string) => {
                  if (validateDateNotFuture(value, 'dataInicial', 'Data início')) {
                    clearErrors('dataInicial')
                  }
                  setValue('dataInicial', value, { shouldDirty: true })
                }}
              />
            </div>
            <div className={style.formControl}>
              <Input
                type='date'
                max={today}
                label='Data final'
                id='data_final'
                value={formatDateToInputValue(watch('dataFim'))}
                error={errors?.dataFim?.message}
                onChange={(value: string) => {
                  if (validateDateNotFuture(value, 'dataFim', 'Data final')) {
                    clearErrors('dataFim')
                  }
                  setValue('dataFim', value, { shouldDirty: true })
                }}
              />
            </div>
          </div>
        )}

        <div className={style.formControl}>
          <SelectAnimalFetchInput
            label='Touro'
            selectBy='id'
            showBy={['cdn', 'nome']}
            filteredSex='Macho'
            hidden={['MT', 'VD']}
            value={watch('touro') || ''}
            error={errors?.touro?.message}
            placeholder='Selecionar Touro'
            onChange={(item: FormattedOption) => {
              setValue('touro', item.id, { shouldDirty: true })
              clearErrors('touro')
            }}
          />
        </div>
      </div>
    </section>
  )
}
